import { useEffect } from 'react';

export const SEO = ({ title, description, path }) => {
  useEffect(() => {
    try {
      if (title) {
        document.title = `${title} | Civil Nexus`;
      }
      if (description) {
        let metaDesc = document.querySelector('meta[name="description"]');
        if (!metaDesc) {
          metaDesc = document.createElement('meta');
          metaDesc.name = 'description';
          document.head.appendChild(metaDesc);
        }
        metaDesc.setAttribute('content', description);
      }
      if (path) {
        let canonical = document.querySelector('link[rel="canonical"]');
        if (!canonical) {
          canonical = document.createElement('link');
          canonical.rel = 'canonical';
          document.head.appendChild(canonical);
        }
        canonical.setAttribute('href', `https://sovereignnexus.github.io${path}`);
      }
    } catch (e) {
      console.warn('SEO application deferred:', e);
    }
  }, [title, description, path]);

  return null;
};

export default SEO;
